import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Region } from '@compumark/order-management-client';

@Component({
  selector: 'app-regions-dialog',
  templateUrl: './regions-dialog.component.html',
  styleUrls: ['./regions-dialog.component.scss'],
  standalone: false,
})
export class RegionsDialogComponent {
  private data = inject(MAT_DIALOG_DATA);

  trademarkName!: string;
  regions!: Region[];
  constructor() {
    this.trademarkName = this.data.trademarkName;
    this.regions = this.data.regions;
  }
}
